/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../textbook/model/CreatedVo';
import DragForm from '../../textbook/model/DragForm';
import ExamCreateForm from '../../textbook/model/ExamCreateForm';
import ExamEditForm from '../../textbook/model/ExamEditForm';
import ExamVo from '../../textbook/model/ExamVo';
import LatestVersionQueryForm from '../../textbook/model/LatestVersionQueryForm';
import LessonCreateForm from '../../textbook/model/LessonCreateForm';
import LessonEditForm from '../../textbook/model/LessonEditForm';
import LessonVo from '../../textbook/model/LessonVo';
import PagingTextBookVo from '../../textbook/model/PagingTextBookVo';
import PagingTextBookWithLatestVersionVo from '../../textbook/model/PagingTextBookWithLatestVersionVo';
import PdfPreviewUrlVo from '../../textbook/model/PdfPreviewUrlVo';
import PdfUploadCompleteForm from '../../textbook/model/PdfUploadCompleteForm';
import SectionCreateForm from '../../textbook/model/SectionCreateForm';
import SectionEditForm from '../../textbook/model/SectionEditForm';
import SectionVo from '../../textbook/model/SectionVo';
import StsAkVo from '../../textbook/model/StsAkVo';
import TextBookAuditStatusStatQueryForm from '../../textbook/model/TextBookAuditStatusStatQueryForm';
import TextBookBasicInfoEditForm from '../../textbook/model/TextBookBasicInfoEditForm';
import TextBookCategoryAndTagForm from '../../textbook/model/TextBookCategoryAndTagForm';
import TextBookCategoryVo from '../../textbook/model/TextBookCategoryVo';
import TextBookCountItemVo from '../../textbook/model/TextBookCountItemVo';
import TextBookCreateForm from '../../textbook/model/TextBookCreateForm';
import TextBookDetailVo from '../../textbook/model/TextBookDetailVo';
import TextBookInfoVo from '../../textbook/model/TextBookInfoVo';
import TextBookVo from '../../textbook/model/TextBookVo';
import TextbookCategoryCreateForm from '../../textbook/model/TextbookCategoryCreateForm';
import TextbookCategoryEditForm from '../../textbook/model/TextbookCategoryEditForm';
import TextbookTagCreateForm from '../../textbook/model/TextbookTagCreateForm';
import TextbookTagEditForm from '../../textbook/model/TextbookTagEditForm';
import TextbookTagVo from '../../textbook/model/TextbookTagVo';
import TextbookVersionAuditForm from '../../textbook/model/TextbookVersionAuditForm';
import TextbookVersionStsAkVo from '../../textbook/model/TextbookVersionStsAkVo';
import TextbookVersionVo from '../../textbook/model/TextbookVersionVo';
import UnitCreateForm from '../../textbook/model/UnitCreateForm';
import UnitForm from '../../textbook/model/UnitForm';
import UnitVo from '../../textbook/model/UnitVo';
import UpdatedVo from '../../textbook/model/UpdatedVo';
  /**
   * TextBook service.
   * @module textbook/api/TextBookApi
   * @version 0.2.0
   */

  /**
   * Constructs a new TextBookApi. 
   * @alias module:textbook/api/TextBookApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 添加lesson
     * @param {module:textbook/model/LessonCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addLesson = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addLesson";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/lesson', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 添加Section
     * @param {module:textbook/model/SectionCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addSection = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addSection";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 添加教材
     * @param {module:textbook/model/TextBookCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addTextBook = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addTextBook";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 创建教材分类
     * @param {module:textbook/model/TextbookCategoryCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addTextBookCategory = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addTextBookCategory";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/textbook_category', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 添加标签
     * @param {module:textbook/model/TextbookTagCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addTextbookTag = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addTextbookTag";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/tag', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 添加Unit
     * @param {module:textbook/model/UnitCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.addUnit = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addUnit";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/unit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 审核版本
     * @param {Integer} id 教材id
     * @param {Integer} versionId 教材版本id
     * @param {module:textbook/model/TextbookVersionAuditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionVo}
     */
this.auditVersion = function(id, versionId, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling auditVersion";
      }

      // verify the required parameter 'versionId' is set
      if (versionId == undefined || versionId == null) {
        throw "Missing the required parameter 'versionId' when calling auditVersion";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling auditVersion";
      }


      var pathParams = {
        'id': id,
        'versionId': versionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version/{versionId}/audit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询lesson信息
     * @param {Integer} id section的id
     * @param {module:textbook/model/ExamCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/CreatedVo}
     */
this.createSectionExam = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling createSectionExam";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling createSectionExam";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}/exam', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取教材上传的版本列表
     * @param {Integer} id 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionStsAkVo}
     */
this.createVersion = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling createVersion";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionStsAkVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id删除lesson信息
     * @param {Integer} id lesson的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteLesson = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteLesson";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/lesson/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id删除Section信息
     * @param {Integer} id section的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteSection = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteSection";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id删除删除教材
     * @param {Integer} id 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteTextBook = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteTextBook";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id删除教材分类
     * @param {Integer} id 分类id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteTextBookCategory = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteTextBookCategory";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/textbook_category/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除标签
     * @param {Integer} id 标签id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteTextbookTag = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteTextbookTag";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/tag/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id删除Unit信息
     * @param {Integer} id Unit的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.deleteUnit = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteUnit";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/unit/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 拖拽lesson，调整位置
     * @param {module:textbook/model/DragForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.dragLesson = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dragLesson";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/lesson/sort', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 拖拽Section，调整位置
     * @param {module:textbook/model/DragForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.dragSection = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dragSection";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section/drag', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 拖拽Unit，调整位置
     * @param {module:textbook/model/DragForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.dragUnit = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dragUnit";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/unit/drag', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询教材
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.bookType 类型 1:数字教材 2:电子书
     * @param {Integer} opts.categoryId 分类id
     * @param {Integer} opts.tagId 标签id
     * @param {String} opts.keyword 关键词（模糊搜索书名、作者、ISBN）
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/PagingTextBookVo}
     */
this.findPagingTextBook = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingTextBook";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'bookType': opts['bookType'],
        'categoryId': opts['categoryId'],
        'tagId': opts['tagId'],
        'keyword': opts['keyword']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTextBookVo;
      return this.apiClient.callApi(
        '/api/textbook/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询教材, 每个教材包含最新版本（如果存在）
     * @param {Integer} pageNum 页码
     * @param {module:textbook/model/LatestVersionQueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/PagingTextBookWithLatestVersionVo}
     */
this.findPagingTextBookWithLatestVersion = function(pageNum, body) {
      var postBody = body;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingTextBookWithLatestVersion";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling findPagingTextBookWithLatestVersion";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTextBookWithLatestVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/list_with_latest_version', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询教材
     * @param {Integer} id 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextBookDetailVo}
     */
this.findTextBookById = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling findTextBookById";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextBookDetailVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取所有标签
     * @param {Object} opts Optional parameters
     * @param {String} opts.name 标签名称搜索
     * @param {Integer} opts.bookType 书籍类型（1:数字教材, 2:电子书）
     * @param {String} opts.bookName 电子书名（模糊匹配）
     * @param {Integer} opts.categoryId 分类id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextbookTagVo>}
     */
this.findTextbookTagList = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'name': opts['name'],
        'bookType': opts['bookType'],
        'bookName': opts['bookName'],
        'categoryId': opts['categoryId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookTagVo];
      return this.apiClient.callApi(
        '/api/textbook/tag', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取电子书PDF预览URL（管理员预览）
     * 获取带签名的PDF预览URL，供管理员预览电子书内容 - URL自动过期（1小时） - 禁用打印、复制、导出 - 自动添加管理员水印（\&quot;管理员预览\&quot; + 操作人姓名） 
     * @param {Integer} id 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/PdfPreviewUrlVo}
     */
this.getEbookPreviewUrl = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getEbookPreviewUrl";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PdfPreviewUrlVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/preview_url', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询lesson信息
     * @param {Integer} id lesson的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/LessonVo}
     */
this.getLesson = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getLesson";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = LessonVo;
      return this.apiClient.callApi(
        '/api/textbook/lesson/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取PDF上传STS令牌
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.textbookId 教材id，用于限定上传目录
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/StsAkVo}
     */
this.getPdfStsAk = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'textbook_id': opts['textbookId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = StsAkVo;
      return this.apiClient.callApi(
        '/api/textbook/pdf_sts_ak', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询lesson信息
     * @param {Integer} id section的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/SectionVo}
     */
this.getSection = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getSection";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = SectionVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询lesson信息
     * @param {Integer} id section的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/ExamVo}
     */
this.getSectionExam = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getSectionExam";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = ExamVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}/exam', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取oss访问令牌
     * @param {Integer} id 教材id
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.unitId 单元id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/StsAkVo}
     */
this.getStsAk = function(id, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getStsAk";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'unitId': opts['unitId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = StsAkVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/get_sts_ak', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 统计每个审核状态和全部教材的教材数量
     * @param {module:textbook/model/TextBookAuditStatusStatQueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextBookCountItemVo>}
     */
this.getTextBookAuditStatusStat = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getTextBookAuditStatusStat";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextBookCountItemVo];
      return this.apiClient.callApi(
        '/api/textbook/audit_status_stat', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取教材章节
     * @param {Integer} id 教材id
     * @param {Integer} type 1内嵌资源，0外挂资源
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/UnitVo>}
     */
this.getToc = function(id, type) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getToc";
      }

      // verify the required parameter 'type' is set
      if (type == undefined || type == null) {
        throw "Missing the required parameter 'type' when calling getToc";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'type': type
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [UnitVo];
      return this.apiClient.callApi(
        '/api/textbook/{id}/toc', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询lesson信息
     * @param {Integer} id unit的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UnitVo}
     */
this.getUnit = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getUnit";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UnitVo;
      return this.apiClient.callApi(
        '/api/textbook/unit/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取审核版本
     * @param {Integer} id 教材id
     * @param {Integer} versionId 教材版本id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionVo}
     */
this.getVersion = function(id, versionId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getVersion";
      }

      // verify the required parameter 'versionId' is set
      if (versionId == undefined || versionId == null) {
        throw "Missing the required parameter 'versionId' when calling getVersion";
      }


      var pathParams = {
        'id': id,
        'versionId': versionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version/{versionId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取教材上传的版本列表
     * @param {Integer} id 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextbookVersionVo>}
     */
this.getVersionList = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getVersionList";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextbookVersionVo];
      return this.apiClient.callApi(
        '/api/textbook/{id}/version', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * PDF上传完成回调
     * @param {Integer} id 教材id
     * @param {module:textbook/model/PdfUploadCompleteForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.pdfUploadComplete = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling pdfUploadComplete";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling pdfUploadComplete";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/pdf_upload_complete', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 发布版本上线
     * @param {Integer} id 教材id
     * @param {Integer} versionId 教材版本id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionVo}
     */
this.releaseVersion = function(id, versionId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling releaseVersion";
      }

      // verify the required parameter 'versionId' is set
      if (versionId == undefined || versionId == null) {
        throw "Missing the required parameter 'versionId' when calling releaseVersion";
      }


      var pathParams = {
        'id': id,
        'versionId': versionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version/{versionId}/release', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 按标题搜索教材
     * @param {Object} opts Optional parameters
     * @param {String} opts.text 教材标题
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextBookVo>}
     */
this.searchTextBook = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'text': opts['text']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextBookVo];
      return this.apiClient.callApi(
        '/api/textbook/search', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 教材分类 （老版本接口，暂时保留兼容现有程序）
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextBookCategoryVo>}
     */
this.textBookCategory = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextBookCategoryVo];
      return this.apiClient.callApi(
        '/api/textbook/category', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 教材分类
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.bookType 类型 1:数字教材 2:电子书
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:textbook/model/TextBookCategoryVo>}
     */
this.textBookCategoryList = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'bookType': opts['bookType']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [TextBookCategoryVo];
      return this.apiClient.callApi(
        '/api/textbook/textbook_category', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取教材详细信息
     * @param {Integer} id 书的id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextBookInfoVo}
     */
this.textBooksInfo = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling textBooksInfo";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextBookInfoVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/info', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改lesson信息
     * @param {Integer} id lesson的id
     * @param {module:textbook/model/LessonEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateLesson = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateLesson";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateLesson";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/lesson/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改section信息
     * @param {Integer} id section的id
     * @param {module:textbook/model/SectionEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateSection = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateSection";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateSection";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改section信息
     * @param {Integer} id section的id
     * @param {module:textbook/model/ExamEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateSectionExam = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateSectionExam";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateSectionExam";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/section/{id}/exam', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id修改教材基本信息（不含分类和标签）
     * @param {Integer} id 教材id
     * @param {module:textbook/model/TextBookBasicInfoEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateTextBook = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateTextBook";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateTextBook";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id修改教材分类
     * @param {Integer} id 分类id
     * @param {module:textbook/model/TextbookCategoryEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateTextBookCategory = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateTextBookCategory";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateTextBookCategory";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/textbook_category/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 按字段修改教材的分类、标签、状态、排序和销售属性（未传字段不修改）
     * @param {Integer} id 教材id
     * @param {module:textbook/model/TextBookCategoryAndTagForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateTextBookCategoryAndTag = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateTextBookCategoryAndTag";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateTextBookCategoryAndTag";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/category_and_tag', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改标签
     * @param {Integer} id 标签id
     * @param {module:textbook/model/TextbookTagEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateTextbookTag = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateTextbookTag";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateTextbookTag";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/tag/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改Unit信息
     * @param {Integer} id Unit的id
     * @param {module:textbook/model/UnitForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/UpdatedVo}
     */
this.updateUnit = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateUnit";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateUnit";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/textbook/unit/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 上传完毕提交审核
     * @param {Integer} id 教材id
     * @param {Integer} versionId 教材版本id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionVo}
     */
this.uploadCompleteVersion = function(id, versionId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling uploadCompleteVersion";
      }

      // verify the required parameter 'versionId' is set
      if (versionId == undefined || versionId == null) {
        throw "Missing the required parameter 'versionId' when calling uploadCompleteVersion";
      }


      var pathParams = {
        'id': id,
        'versionId': versionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version/{versionId}/upload_complete', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 撤回版本
     * @param {Integer} id 教材id
     * @param {Integer} versionId 教材版本id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:textbook/model/TextbookVersionVo}
     */
this.withdrawVersion = function(id, versionId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling withdrawVersion";
      }

      // verify the required parameter 'versionId' is set
      if (versionId == undefined || versionId == null) {
        throw "Missing the required parameter 'versionId' when calling withdrawVersion";
      }


      var pathParams = {
        'id': id,
        'versionId': versionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookVersionVo;
      return this.apiClient.callApi(
        '/api/textbook/{id}/version/{versionId}/withdraw', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
